import DashboardsPage from './DashboardsPage';

export default DashboardsPage;
